import { render, staticRenderFns } from "./WillBeInTouchHome.vue?vue&type=template&id=6189f990&"
import script from "./WillBeInTouchHome.vue?vue&type=script&lang=js&"
export * from "./WillBeInTouchHome.vue?vue&type=script&lang=js&"
import style0 from "./WillBeInTouchHome.vue?vue&type=style&index=0&id=6189f990&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports